enum RFPSubmitResponseStatus {
  ALLOWED = 'Allowed',
  INCOMPLETE_QUESTIONS = 'Incomplete Questions',
  NO_SUBMISSIONS_REMAINING = 'No Submissions Remaining',
}

export default RFPSubmitResponseStatus;
